(function () {
  class GambleIntro extends PIXI.Container {
    constructor() {
      super();

      this._freespins = undefined;
      this._callbackOnBaseHidden = undefined;
      this._callback = undefined;
      this._screenDim = undefined;
      this._splashContinue = undefined;
      this._gambleIntroAnimatedPanel = undefined;
      this._gambleIntroInnerPanel = undefined;

      this._totemParent = undefined;
      this._popup = undefined;
      this._introText1 = undefined;
      this._freespinIntroElements = [];
      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._startFreeSpinsButton = undefined;
      this._gambleButton = undefined;

      this.freeSpinsFsCountText = undefined;
      this._winChance = undefined;

      this._freeSpinsIntroOutro = undefined;
    }

    initialise() {
      const self = this;

      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._gambleBacker = resourceManager.get('gambleBacker');
      this._gambleBacker.visible = false;

      this._gamblePanel = resourceManager.get('gambleIntroContainer:GambleIntro:gambleIntroFullPanelContainer');
      this._gamblePanel.visible = false;

      this._gambleIntroAnimatedPanel = resourceManager.get(
        'gambleIntroContainer:GambleIntro:gambleIntroFullPanelContainer:gambleIntroAnimatedPanel'
      );

      this.freeSpinsFsCountText = resourceManager.get(
        'gambleIntroContainer:GambleIntro:gambleIntroFullPanelContainer:freeSpinsFsCountText'
      );

      this._startFreeSpinsButton = resourceManager.get(
        'gambleIntroContainer:GambleIntro:gambleIntroFullPanelContainer:freeSpinsButton'
      );

      this._gambleButton = resourceManager.get(
        'gambleIntroContainer:GambleIntro:gambleIntroFullPanelContainer:gambleButton'
      );

      this._gambleDisclaimer = resourceManager.get('gambleDisclaimerContainer:GambleDisclaimer');
      this._gambleSpin = resourceManager.get('gambleSpinContainer:GambleSpin');

      this._startFreeSpinsButton.mousedown = this._startFreeSpinsButton.touchstart = this.onClickedStart.bind(this);
      this._gambleButton.mousedown = this._gambleButton.touchstart = this.onClickedGamble.bind(this);

      this._freeSpinsIntroOutro = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro');

      this.orientationChange();

      messageBus.subscribe('Gamble:Risk', this.onCommittedToGamble.bind(this));
      messageBus.subscribe('Gamble:Collect', this.onClickedStart.bind(this));
      messageBus.subscribe('Gamble:OfferGamble', this.onGambleOffered.bind(this));

      Reflex.registerEventHandler('orientationChange', this.orientationChange.bind(this));
    }

    orientationChange() {
      this._winAnimIntroPositions = [];
    }

    onClickedStart() {
      this._startFreeSpinsButton.interactive = false;
      this._gambleButton.interactive = false;

      this.fadeOut(this._gamblePanel, 1.0);
      this.riseUp(this._gamblePanel, 1.0, this.onGambleSkipped.bind(this));

      // let inRecovery = gameController.getIsRecovery();
      // if (!inRecovery) {
      //   this.fadeOut(this._gamblePanel, 1.0);
      //   this.riseUp(this._gamblePanel, 1.0, this.onGambleSkipped.bind(this));
      // } else {
      //   this.onGambleSkipped();
      // }
      soundManager.play(soundManifest.getSound('buttonPress'));
    }

    onGambleSkipped() {
      this._callback('collect');
      this.visible = false;
      this._gambleIntroAnimatedPanel.stop();
    }

    onCommittedToGamble() {
      this._callback('gambled');
    }

    reactivate(freespins, nextFreeSpins, winChance, loseChance, callback) {
      this._freespins = freespins;
      this._nextFreeSpins = nextFreeSpins;
      this._winChance = winChance;
      this._loseChance = loseChance;
      this._callback = callback;

      this._gambleSpin.start(freespins, nextFreeSpins, winChance, loseChance, undefined);
    }

    onGambleOffered() {
      let showDisclaimerButton = resourceManager.get('gambleDisclaimerContainer:GambleDisclaimer:showAgainToggle');
      let inRecovery = gameController.getIsRecovery();
      let show = showDisclaimerButton.getShowDisclaimer();

      const self = this;
      if (show && !inRecovery) {
        this._gambleDisclaimer.start(this._freespins, this._nextFreeSpins, this._winChance, this._loseChance);
      } else {
        this._gambleSpin.start(this._freespins, this._nextFreeSpins, this._winChance, this._loseChance, true);
      }
    }

    onClickedGamble() {
      messageBus.postImmediate('Gamble:OfferGamble');
      soundManager.play(soundManifest.getSound('buttonPress'));
    }

    doShowIntro(numFS, callback) {
      this._freespins = numFS;
      this._callback = callback;
      this._freeSpinsIntroOutro.showIntro(this._freespins, this._callback);
    }

    start(numFS, nextFreeSpins, winChance, loseChance, hiddenCallback, callback) {
      this._freespins = numFS;
      this._nextFreeSpins = nextFreeSpins;
      this._winChance = winChance;
      this._loseChance = loseChance;

      this._callbackOnBaseHidden = hiddenCallback;
      this._callback = callback;

      this.visible = true;

      resourceManager.getContainer('gambleIntroContainer').visible = true;

      this._gamblePanel.alpha = 0;
      this._gamblePanel.visible = true;

      // var recoveryController = resourceManager.getController('GameRecoveryController');

      // let inRecovery = gameController.getIsRecovery();
      // if (inRecovery) {
      //   recoveryController.onIntroVisible();
      //   this.onGambleOffered();
      // }

      messageBus.post('Gamble:IntroVisible');
      this._callbackOnBaseHidden();

      //this.showIntro();
    }

    showIntro() {
      gameController.fullScreenBubblesFront.startBubbles();
      timerManager.addTimeout(500, function () {
        gameController.fullScreenBubblesFront.stopBubbles();
      });
      gameController.fullScreenBubblesBack.startBubbles();
      musicManager.onPlayBubbleIntro();

      this._gambleIntroAnimatedPanel.play();
      this.freeSpinsFsCountText.setTranslationParameters(this._freespins);
      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      let panelDelay = 0.5;
      let panelDuration = 3.0;
      this.floatIn(this._gamblePanel, panelDelay, panelDuration);
      this.fadeIn(this._gamblePanel, 1.0, 1.0, panelDelay);

      let self = this;
      timerManager.addTimeout(1500, function () {
        gameData.topLayerMeters.visible = true;
        self.setActive();
      });

      // let inRecovery = gameController.getIsRecovery();
      // //if (!inRecovery) {
      // gameController.fullScreenBubblesFront.startBubbles();
      // timerManager.addTimeout(500, function () {
      //   gameController.fullScreenBubblesFront.stopBubbles();
      // });
      // gameController.fullScreenBubblesBack.startBubbles();
      musicManager.onPlayBubbleIntro();
      // gameData.topLayerMeters.visible = true;

      // this._gambleIntroAnimatedPanel.play();
      // this.freeSpinsFsCountText.setTranslationParameters(this._freespins);
      // this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      // let panelDelay = 0.5;
      // let panelDuration = 3.0;
      // this.floatIn(this._gamblePanel, panelDelay, panelDuration);
      // this.fadeIn(this._gamblePanel, 1.0, 1.0, panelDelay);

      // let self = this;
      // timerManager.addTimeout(1500, function () {
      //   self.setActive();
      // });
      //}
    }

    setActive() {
      this._startFreeSpinsButton.interactive = true;
      this._gambleButton.interactive = true;
    }

    floatIn(object, delay, duration) {
      gsap.fromTo(
        object,
        {
          x: 0,
          y: 500,
        },
        {
          delay,
          duration,
          ease: 'elastic.out(1.0, 0.3)',
          x: 0,
          y: 0,
          onComplete: () => {
            //this.setActive();
          },
        }
      );
    }

    bounceIn(object, delay) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: 1,
          ease: 'Bounce.easeOut',
          x: 1,
          y: 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
        }
      );
    }

    fadeIn(object, alpha, duration, delay) {
      gsap.fromTo(
        object,
        {
          alpha: 0,
        },
        {
          delay: delay,
          duration: duration,
          alpha: alpha,
          onStart: () => {
            object.visible = true;
          },
        }
      );
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, 'x'),
        y: gsap.getProperty(object, 'y'),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: 'power4.in',
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }
        },
      });
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: 'power4.in',
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;
        },
      });
    }
  }

  let gambleIntroCreator = function (json) {
    return new GambleIntro();
  };

  let gambleIntroInitialiser = function (json, fsIntro) {
    fsIntro.initialise();
  };

  let gambleIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    'GambleIntro',
    gambleIntroCreator,
    gambleIntroInitialiser,
    gambleIntroFilesRequired
  );
})();
